module.exports = __webpack_public_path__ + "static/media/03.dd6cc554.webp";